import { render, staticRenderFns } from "./CompleteStockCard.vue?vue&type=template&id=529f4d03&scoped=true&"
import script from "./CompleteStockCard.vue?vue&type=script&lang=js&"
export * from "./CompleteStockCard.vue?vue&type=script&lang=js&"
import style0 from "./CompleteStockCard.vue?vue&type=style&index=0&id=529f4d03&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529f4d03",
  null
  
)

export default component.exports